import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M19 4H5C4.2044 4 3.4413 4.3161 2.8787 4.8787C2.3161 5.4413 2 6.2044 2 7V17C2 17.7956 2.3161 18.5587 2.8787 19.1213C3.4413 19.6839 4.2044 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V7C22 6.2044 21.6839 5.4413 21.1213 4.8787C20.5587 4.3161 19.7956 4 19 4ZM18.33 6L12 10.75L5.67 6H18.33ZM19 18H5C4.7348 18 4.4804 17.8946 4.2929 17.7071C4.1054 17.5196 4 17.2652 4 17V7.25L11.4 12.8C11.5731 12.9298 11.7836 13 12 13C12.2164 13 12.4269 12.9298 12.6 12.8L20 7.25V17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18Z" })
	})
});
export { SvgEnvelope as ReactComponent };
